import React from 'react';
import { Box } from '@mui/material';
import { JournalsTableDesktop } from './JournalsTableDesktop';
import { JournalsTableMobile } from './JournalsTableMobile';
import {
  MasterListFilter,
  MasterListFilterKeys,
  MasterListJournal,
} from '../../../types/MasterList.types';

interface JournalsTableProps {
  journals: MasterListJournal[];
  filters: MasterListFilter;
  selectedFilters: MasterListFilter;
  hasFiltersApplied?: boolean;
  isLoading?: boolean;
  onToggleFilter: (type: MasterListFilterKeys, value: string) => void;
  onJournalClick: (journal: MasterListJournal) => void;
}

export const JournalsTable = ({
  journals,
  filters,
  selectedFilters,
  hasFiltersApplied = false,
  isLoading = false,
  onToggleFilter,
  onJournalClick,
}: JournalsTableProps) => {
  return (
    <>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <JournalsTableDesktop
          journals={journals}
          filters={filters}
          selectedFilters={selectedFilters}
          isLoading={isLoading}
          onToggleFilter={onToggleFilter}
          onJournalClick={onJournalClick}
        />
      </Box>
      <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
        <JournalsTableMobile
          journals={journals}
          filters={filters}
          selectedFilters={selectedFilters}
          hasFiltersApplied={hasFiltersApplied}
          isLoading={isLoading}
          onToggleFilter={onToggleFilter}
          onJournalClick={onJournalClick}
        />
      </Box>
    </>
  );
};
